import { ClientOnboardingAgreementAcceptanceEntity } from '@/entities/client-onboarding.entity';
import { EndpointOptions } from '@/types/endpoint.options';
import { getAxiosInstance, withSuppressedErrorToast } from '@/client/get-axios-instance';
import { buildMarketplaceApiPath } from '@/repositories/marketplace-api-paths';
import { OnboardingAgreementLocale } from '@/shared/onboarding-agreement';

type ClientOnboardingAgreementAcceptancePayload = {
    locale: OnboardingAgreementLocale;
};

class ClientOnboardingRepository {
    private readonly _agreementAxios = getAxiosInstance(buildMarketplaceApiPath('onboarding/agreement'));

    acceptAgreement(data: ClientOnboardingAgreementAcceptancePayload, options?: EndpointOptions) {
        return this._agreementAxios.post<ClientOnboardingAgreementAcceptanceEntity>(
            '',
            data,
            withSuppressedErrorToast({
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            }),
        );
    }
}

export const createClientOnboardingRepository = () => new ClientOnboardingRepository();

export const clientOnboardingRepository = createClientOnboardingRepository();
